/* Breakfree welcome scratch card */
(function () {
  'use strict';
  if (window.bfWelcome) return;
  var root = document.getElementById('bf-welcome');
  var dataEl = document.getElementById('bf-welcome-data');
  if (!root || !dataEl) return;
  var C;
  try { C = JSON.parse(dataEl.textContent); } catch (e) { console.error('[bf-welcome] settings could not be read', e); return; }

  var T = C.t || {};
  var R = C.root || '/';
  if (R.slice(-1) !== '/') R += '/';
  var KEY = 'bfw1';
  var DAY = 864e5;
  var design = !!(window.Shopify && Shopify.designMode);
  var persist = !design;
  var PRIZES = (C.prizes || []).filter(function (p) { p.w = Math.max(0, +p.w || 0); return p.code && (p.id !== 'gift' || p.vid); });
  if (!PRIZES.some(function (p) { return p.w > 0; })) return;

  var SCRIB = 'M62 9C150 -2 262 6 290 38C310 66 250 94 150 95C60 96 4 80 6 50C8 22 70 6 160 7C200 8 236 12 262 22';
  var I = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#25D366" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2z"/><path fill="#fff" d="M17.2 14.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.1l-.9 1.1c-.2.2-.3.2-.6.1-1.5-.7-2.6-1.6-3.4-3-.3-.5.3-.4.7-1.4.1-.2 0-.4 0-.5l-.9-2.1c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3 1.8.8 2.6.8 3.5.7.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.2-.3-.3-.6-.4z"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v9h14v-9M12 8S10.5 3 7.8 3.6C5.6 4.1 6.4 8 12 8zm0 0s1.5-5 4.2-4.4C18.4 4.1 17.6 8 12 8z"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="13.5" r="7.5"/><path d="M12 10v3.8l2.4 2M9.5 2.8h5"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 7h12l1 13H5z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg>'
  };

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function circ(t) { return '<span class="bfw-c">' + esc(t) + '<svg viewBox="0 0 300 100" preserveAspectRatio="none" aria-hidden="true"><path pathLength="1" d="' + SCRIB + '"/></svg></span>'; }
  function load() { if (!persist) return {}; try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save() { if (!persist) return; try { localStorage.setItem(KEY, JSON.stringify(st)); } catch (e) {} }
  function byId(id) { for (var i = 0; i < PRIZES.length; i++) if (PRIZES[i].id === id) return PRIZES[i]; return null; }
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return (h >>> 0); }
  function pick(n) {
    var live = PRIZES.filter(function (p) { return p.w > 0; }), total = 0;
    live.forEach(function (p) { total += p.w; });
    var r = (hash('bf' + n) % 10000) / 10000 * total;
    for (var i = 0; i < live.length; i++) { r -= live[i].w; if (r < 0) return live[i]; }
    return live[0];
  }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  function post(path, body) {
    return window.fetch(R + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  /* ---------- state ---------- */
  var st = load();
  var prize = st.p ? byId(st.p) : null;
  if (st.p && !prize) { st = {}; save(); }
  var step = prize && st.w ? 'won' : 'intro';
  var num = st.n || '';
  var copied = false, isOpen = false, armed = false, ov = null, pillEl = null, SC = null, showReveal = false, revealTimer = null;
  var GIFT = byId('gift'), MIN = Math.round((parseFloat(C.giftMin) || 0) * 100), inCart = false, giftKey = null, giftOk = false, syncing = false;
  function isGift() { return !!(prize && prize.id === 'gift'); }

  /* ---------- claim timer ---------- */
  var MINS = Math.max(0, parseInt(C.mins, 10) || 0), SPAN = MINS * 60000, tickT = null, pendingCo = 0;
  function timerOn() { return !!(MINS && prize && st.w && st.e && !st.x && !st.c); }
  function left() { return Math.max(0, (st.e || 0) - Date.now()); }
  function fmt(ms) { var x = Math.ceil(ms / 1000), m = Math.floor(x / 60), r = x % 60; return m + ':' + (r < 10 ? '0' : '') + r; }
  function pct(ms) { return (SPAN ? Math.min(100, ms / SPAN * 100) : 0).toFixed(1) + '%'; }
  function startTimer() { if (MINS && !st.e && !st.x && !st.c) { st.e = Date.now() + SPAN; save(); } startTick(); }
  function timerHTML() {
    if (!MINS || st.c || !prize) return '';
    if (st.x) return '<div class="bfw-timer off">' + I.clock + '<span>' + esc(T.timeUp) + '</span></div>';
    if (!st.e) return '';
    var ms = left();
    return '<div class="bfw-timer' + (ms <= 60000 ? ' hurry' : '') + '" role="timer">' + I.clock + '<span>' + esc(T.timer) + '</span><b data-bfw-left>' + fmt(ms) + '</b><i class="bfw-timer__bar"><i data-bfw-bar style="width:' + pct(ms) + '"></i></i></div>';
  }
  function startTick() { if (tickT || !timerOn()) return; tickT = setInterval(tick, 1000); tick(); }
  function stopTick() { clearInterval(tickT); tickT = null; }
  function tick() {
    if (!timerOn()) { stopTick(); bars(false); if (pillEl) { hidePill(); showPill(); } return; }
    var ms = left();
    if (ms <= 0) { if (Date.now() - pendingCo < 60000) return; expire(); return; }
    bars(true);
    var txt = fmt(ms), w = pct(ms), hurry = ms <= 60000;
    [].forEach.call(document.querySelectorAll('[data-bfw-left]'), function (n) { if (n.textContent !== txt) n.textContent = txt; });
    [].forEach.call(document.querySelectorAll('[data-bfw-bar]'), function (n) { n.style.width = w; });
    [].forEach.call(document.querySelectorAll('.bfw-timer,.bfw-pill,.bfw-cbar'), function (n) { if (!n.classList.contains('off')) n.classList.toggle('hurry', hurry); });
  }
  /* bar above every checkout button: "10% off applied · ends in 4:59" */
  function barKind() { return isGift() ? (inCart ? 'g' : 'w') : 'c'; }
  function barHTML() {
    var k = barKind(), tpl = k === 'g' ? T.cbarGift : k === 'w' ? T.cbarWait : T.cbarCode;
    return '<span class="bfw-cbar__i">' + I.gift + '</span><span class="bfw-cbar__t">' + esc(tpl || '').replace('[prize]', '<b>' + esc(cap(prize.core)) + '</b>').replace('[time]', '<b data-bfw-left>' + fmt(left()) + '</b>') + '</span>';
  }
  function bars(on) {
    var keep = [];
    if (on && prize) {
      [].forEach.call(document.querySelectorAll('#bf-cart .bfk-co, button[name="checkout"], input[name="checkout"]'), function (b) {
        if (b.hidden || (b.closest && b.closest('#bf-welcome,#bf-offer'))) return;
        var box = (b.closest && b.closest('.bfk-co-f')) || b, prev = box.previousElementSibling;
        if (prev && prev.classList.contains('bfw-cbar')) {
          if (prev.getAttribute('data-k') !== barKind()) { prev.setAttribute('data-k', barKind()); prev.innerHTML = barHTML(); }
          keep.push(prev); return;
        }
        if (!box.parentNode) return;
        var bar = document.createElement('div');
        bar.className = 'bfw-cbar'; bar.setAttribute('role', 'timer'); bar.setAttribute('data-k', barKind()); bar.innerHTML = barHTML();
        box.parentNode.insertBefore(bar, box); keep.push(bar);
      });
    }
    [].forEach.call(document.querySelectorAll('.bfw-cbar'), function (n) { if (keep.indexOf(n) < 0 && n.parentNode) n.parentNode.removeChild(n); });
  }
  /* time ran out before checkout: take the prize off the cart */
  function expire() {
    if (st.x || !prize) return;
    st.x = 1; save(); stopTick(); bars(false);
    giftKey = null; note();
    if (isOpen && step === 'won') render();
    if (pillEl) { hidePill(); showPill(); setTimeout(hidePill, 8000); }
    if (design) return;
    getCart().then(function (cart) {
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var code = isGift() ? (GIFT && GIFT.code) : prize.code;
      var list = codes.filter(function (c) { return !sameCode(c, code); }), job = {}, any = false;
      if (list.length !== codes.length) { job.discount = list.join(','); any = true; }
      if (isGift()) {
        var up = {};
        (cart.items || []).forEach(function (i) { if (i.properties && i.properties._bf_welcome) { up[i.key] = 0; any = true; } });
        job.updates = up;
      }
      if (!any) return;
      syncing = true;
      return post('cart/update.js', job).then(function () { syncing = false; inCart = false; kRefresh(); }, function () { syncing = false; });
    }).catch(function () {});
  }
  function kRefresh() { var k = window.kachingCartApi; if (!window.bfCart && k && k.refreshCart) try { k.refreshCart(); } catch (e) {} }
  /* going to checkout in time = claimed, the timer stops */
  function claimNow() { if (timerOn()) { st.c = Date.now(); save(); } }
  function coEl(t) { return t && t.closest ? t.closest('button[name="checkout"],input[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"],.bfk-co') : null; }
  window.addEventListener('click', function (e) { if (timerOn() && coEl(e.target)) pendingCo = Date.now(); }, true);
  window.addEventListener('pagehide', function () { if (pendingCo && Date.now() - pendingCo < 120000) claimNow(); });
  document.addEventListener('bf:checkout', claimNow);
  document.addEventListener('bf:offer-close', function () { pendingCo = 0; });

  /* ---------- markup ---------- */
  function tilesHTML() {
    return '<div class="bfw-tiles">' + PRIZES.map(function (p, i) {
      if (p.id === 'gift') return '<div class="bfw-tile gift">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="46" height="46">' : '') + '<b>' + esc(p.big) + '</b><span>' + esc(p.small) + '</span></div>';
      return '<div class="bfw-tile" style="--c:' + (i % 2 ? 'var(--mint)' : 'var(--ws)') + '"><b>' + esc(p.big) + '</b><span>' + esc(p.small) + '</span></div>';
    }).join('') + '</div>';
  }
  function faceHTML() {
    if (!prize) return '<div class="bfw-face"><div class="t"><b>?</b></div></div>';
    var p = prize, img = p.id === 'gift' && p.img ? '<img src="' + esc(p.img) + '" alt="">' : '';
    return '<div class="bfw-face' + (img ? ' gift' : '') + '">' + img + '<div class="t"><b>' + esc(p.big) + '</b><span>' + esc(p.small) + '</span><em>' + esc(p.id === 'gift' ? T.chipGift : p.code) + '</em></div></div>';
  }
  function burstHTML() {
    var cols = ['#D7263D', '#1F6B4A', '#F7D7DF', '#DCEFE5', '#E3A35B', '#E4E3F4', '#0E0F0D', '#D7E9F8'], s = '';
    for (var i = 0; i < 26; i++) { var a = i / 26 * Math.PI * 2 + (i % 2 ? .2 : 0), r = 120 + (i % 4) * 38; s += '<i style="--c:' + cols[i % cols.length] + ';--x:' + Math.round(Math.cos(a) * r) + 'px;--y:' + Math.round(Math.sin(a) * r) + 'px;animation-delay:' + (i % 3) * .05 + 's"></i>'; }
    return '<div class="bfw-burst">' + s + '</div>';
  }
  function bodyHTML() {
    if (step === 'intro') {
      return '<span class="bfw-kick">' + esc(T.kick) + '</span>' +
        '<h2 class="bfw-hl" id="bfw-title">' + esc(T.h1) + '<br>' + circ(T.h1c) + '</h2>' +
        '<p class="bfw-sub">' + esc(T.sub) + '</p>' + tilesHTML() +
        '<button type="button" class="bfw-cta bfw-pulse" data-bfw="next">' + esc(T.cta) + '</button>' +
        (T.proof ? '<p class="bfw-proof">' + I.check + esc(T.proof) + '</p>' : '') +
        '<button type="button" class="bfw-later" data-bfw="close">' + esc(T.later) + '</button>';
    }
    if (step === 'number') {
      return '<span class="bfw-kick">' + esc(T.nKick) + '</span>' +
        '<h2 class="bfw-hl" id="bfw-title">' + esc(T.nH) + '<br>' + circ(T.nHc) + '</h2>' +
        '<p class="bfw-sub">' + esc(T.nSub) + '</p>' +
        '<form class="bfw-form" novalidate><label class="bfw-field"><span class="bfw-cc"><span aria-hidden="true">' + esc(C.flag || '') + '</span>+' + esc(C.cc) + '</span>' +
        '<input type="tel" inputmode="tel" autocomplete="tel-national" name="bfw-phone" placeholder="' + esc(C.ph) + '" value="' + esc(num) + '" aria-label="WhatsApp number"><span class="bfw-wa">' + I.wa + '</span></label>' +
        '<div class="bfw-err" role="alert"></div><button type="submit" class="bfw-cta">' + esc(T.nCta) + '</button></form>' +
        (T.fine ? '<p class="bfw-fine">' + esc(T.fine) + '</p>' : '');
    }
    if (step === 'scratch') {
      return '<span class="bfw-kick">' + esc(T.sKick) + '</span><h2 class="bfw-hl" id="bfw-title">' + esc(T.sH) + '</h2><p class="bfw-sub">' + esc(T.sSub) + '</p>' +
        (showReveal ? '<button type="button" class="bfw-reveal" data-bfw="reveal">' + esc(T.reveal || 'Reveal it for me') + '</button>' : '');
    }
    var p = prize;
    if (st.x) {
      return '<span class="bfw-kick off">' + esc(T.timeUpKick) + '</span>' +
        '<h2 class="bfw-hl" id="bfw-title">' + esc(p.pre) + '<br>' + circ(p.core) + '</h2>' + timerHTML() +
        '<button type="button" class="bfw-cta" data-bfw="close">' + esc(T.keep) + '</button>';
    }
    if (p.id === 'gift') {
      return '<span class="bfw-kick">' + esc(T.wKick) + '</span>' +
        '<h2 class="bfw-hl" id="bfw-title">' + esc(p.pre) + '<br>' + circ(p.core) + '</h2>' + timerHTML() +
        '<div class="bfw-giftbox"><span class="bfw-giftbox__i">' + I.check + '</span><div><b>' + esc(inCart ? T.inCart : T.notInCart) + '</b><span>' + esc(giftOk ? T.giftOk : T.giftNote) + '</span></div></div>' +
        (inCart
          ? '<button type="button" class="bfw-cta" data-bfw="close">' + I.bag + esc(T.shop) + '</button><button type="button" class="bfw-later" data-bfw="cart">' + esc(T.viewCart) + '</button>'
          : '<button type="button" class="bfw-cta" data-bfw="add">' + I.bag + esc(p.btn || T.shop) + '</button><button type="button" class="bfw-later" data-bfw="close">' + esc(T.keep) + '</button>');
    }
    var main = '<button type="button" class="bfw-cta" data-bfw="close">' + I.bag + esc(T.shop) + '</button>';
    return '<span class="bfw-kick">' + esc(T.wKick) + '</span>' +
      '<h2 class="bfw-hl" id="bfw-title">' + esc(p.pre) + '<br>' + circ(p.core) + '</h2>' + timerHTML() +
      '<div class="bfw-code"><div><small>' + esc(T.codeLbl) + '</small><strong>' + esc(p.code) + '</strong></div><button type="button" class="bfw-copy' + (copied ? ' ok' : '') + '" data-bfw="copy">' + esc(copied ? T.copied + ' ✓' : T.copy) + '</button></div>' +
      '<p class="bfw-ok">' + I.check + '<span>' + esc(T.applied) + '</span></p>' +
      '<p class="bfw-rule">' + esc(p.rule) + '</p>' + main +
      '<button type="button" class="bfw-later" data-bfw="close">' + esc(T.keep) + '</button>';
  }

  /* ---------- open / close ---------- */
  function open() {
    if (isOpen) return;
    if (document.documentElement.classList.contains('bfk-lock')) { setTimeout(open, 3000); return; }
    isOpen = true; disarm(); hidePill();
    var won = step === 'won';
    ov = document.createElement('div');
    ov.className = 'bfw-ov';
    ov.innerHTML = '<div class="bfw-pop" role="dialog" aria-modal="true" aria-labelledby="bfw-title">' +
      '<button type="button" class="bfw-x" data-bfw="close" aria-label="' + esc(T.close) + '">' + I.x + '</button>' +
      '<div class="bfw-media"><div class="bfw-cardwrap' + (won ? ' nohand' : '') + '"><div class="bfw-card' + (won ? ' done' : '') + '">' + faceHTML() +
      (won ? '' : '<canvas aria-hidden="true"></canvas>') + '<span class="bfw-lockchip">' + I.lock + esc(T.lock) + '</span></div></div>' + burstHTML() + '</div>' +
      '<div class="bfw-body"></div></div>';
    root.appendChild(ov);
    lock();
    render();
    if (!won) initCanvas();
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    ov.addEventListener('touchmove', function (e) {
      if (e.target.closest && e.target.closest('canvas')) return;
      var b = e.target.closest && e.target.closest('.bfw-body');
      if (!b || b.scrollHeight <= b.clientHeight + 1) e.preventDefault();
    }, { passive: false });
    var pop = ov.querySelector('.bfw-pop'); pop.setAttribute('tabindex', '-1'); try { pop.focus({ preventScroll: true }); } catch (e) {}
  }
  function close() {
    if (!isOpen) return;
    if (step === 'scratch') finish(true);
    if (step === 'intro' || step === 'number') { st.until = Date.now() + (C.snooze || 3) * DAY; save(); }
    isOpen = false;
    if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
    ov = null; SC = null;
    unlock();
    showPill();
  }
  function render() {
    if (!ov) return;
    var body = ov.querySelector('.bfw-body');
    body.innerHTML = bodyHTML();
    var f = body.querySelector('form');
    if (f) {
      f.addEventListener('submit', submit);
      var inp = f.querySelector('input'), pop = ov.querySelector('.bfw-pop');
      inp.addEventListener('focus', function () { pop.classList.add('kb'); setTimeout(function () { fit(); try { inp.scrollIntoView({ block: 'center' }); } catch (e) {} }, 320); });
      inp.addEventListener('blur', function () { setTimeout(function () { if (document.activeElement !== inp && ov) pop.classList.remove('kb'); fit(); }, 150); });
    }
    if (ov) ov.querySelector('.bfw-pop').classList.toggle('kb', !!(f && document.activeElement === f.querySelector('input')));
  }

  /* ---------- phone: keep the page still and the sheet above the keyboard ---------- */
  var lockY = 0, vv = window.visualViewport;
  function fit() {
    if (!ov) return;
    if (vv) { ov.style.top = vv.offsetTop + 'px'; ov.style.height = vv.height + 'px'; ov.style.bottom = 'auto'; }
  }
  function lock() {
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body.style;
    b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    document.documentElement.classList.add('bfw-lock');
    if (vv) { vv.addEventListener('resize', fit); vv.addEventListener('scroll', fit); }
    fit();
  }
  function unlock() {
    var b = document.body.style;
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
    document.documentElement.classList.remove('bfw-lock');
    if (vv) { vv.removeEventListener('resize', fit); vv.removeEventListener('scroll', fit); }
    window.scrollTo(0, lockY);
  }
  function setStep(s) { step = s; render(); }

  /* ---------- pill ---------- */
  function showPill() {
    if (pillEl || isOpen) return;
    try { if (sessionStorage.getItem('bfw-pill-off')) return; } catch (e) {}
    var won = step === 'won' && prize, gone = won && st.x, timed = won && timerOn();
    pillEl = document.createElement('div');
    pillEl.className = 'bfw-pill' + (gone ? ' off' : '') + (timed && left() <= 60000 ? ' hurry' : '');
    pillEl.innerHTML = '<button type="button" class="bfw-pill__open' + (timed ? ' timed' : '') + '" data-bfw="' + (gone ? 'pilloff' : 'reopen') + '"><span class="bfw-pill__g">' + (gone ? I.clock : I.gift) + '</span><span class="bfw-pill__t">' +
      (gone ? esc(T.pillExpired) + '<small>' + esc(cap(prize.core)) + '</small>'
        : won ? esc(cap(prize.core) + ' ' + T.unlocked) + '<small>' + esc(isGift() ? (inCart ? T.chipGift : T.pillAdd) : String(T.pillCode).replace('[code]', prize.code)) + '</small>' : esc(T.pill)) +
      '</span>' + (timed ? '<b class="bfw-pill__time" data-bfw-left>' + fmt(left()) + '</b>' : '') + '</button><button type="button" class="bfw-pill__x" data-bfw="pilloff" aria-label="' + esc(T.close) + '">' + I.x + '</button>';
    root.appendChild(pillEl);
  }
  function hidePill() { if (pillEl && pillEl.parentNode) pillEl.parentNode.removeChild(pillEl); pillEl = null; }

  /* ---------- number + prize ---------- */
  function clean(v) {
    var d = String(v || '').replace(/\D/g, '');
    var cc = String(C.cc || '');
    if (cc && d.indexOf('00' + cc) === 0) d = d.slice(cc.length + 2);
    else if (cc && d.indexOf(cc) === 0 && d.length > 8) d = d.slice(cc.length);
    if (d.charAt(0) === '0') d = d.slice(1);
    return d;
  }
  function submit(e) {
    e.preventDefault();
    var f = e.target, input = f.querySelector('input'), d = clean(input.value);
    if (d.length < 7 || d.length > 9) {
      var fl = f.querySelector('.bfw-field'); fl.classList.remove('err'); void fl.offsetWidth; fl.classList.add('err');
      f.querySelector('.bfw-err').textContent = T.err;
      return;
    }
    input.blur();
    num = d;
    if (!prize) prize = pick(d);
    st.p = prize.id; st.n = d; st.w = 1; st.t = Date.now(); delete st.until; save();
    applyCode();
    toZoko();
    track();
    var card = ov.querySelector('.bfw-card');
    card.querySelector('.bfw-face').outerHTML = faceHTML();
    card.classList.add('live');
    showReveal = false;
    setStep('scratch');
    clearTimeout(revealTimer);
    revealTimer = setTimeout(function () { if (step === 'scratch' && ov) { showReveal = true; render(); } }, 6000);
  }
  function applyCode() {
    if (design) return;
    var attrs = attrsFor();
    if (isGift()) { post('cart/update.js', { attributes: attrs }).catch(function () {}); return; }
    post('cart/update.js', { discount: prize.code, attributes: attrs }).catch(function () {
      window.fetch(R + 'discount/' + encodeURIComponent(prize.code) + '?redirect=' + encodeURIComponent(R + 'cart.js'), { credentials: 'same-origin' }).catch(function () {});
    });
  }
  function attrsFor() {
    var a = { 'Welcome WhatsApp': '+' + C.cc + ' ' + (num || st.n || ''), 'Welcome prize': cap(prize.core) + ' (' + prize.code + ')' };
    if (prize.tag) a['Welcome tag'] = prize.tag;
    return a;
  }
  /* tag the player as soon as they scratch: Zoko (WhatsApp) + Meta Pixel */
  var ZK_LIST = 'https://web-api.zoko.io/v4/public/popup-campaigns/store/', ZK_SUB = 'https://web3.api.zoko.io/v3/public/popup-campaigns/';
  function norm(x) { return String(x || '').trim().toLowerCase(); }
  function zTags() { var t = []; if (C.zTag) t.push(C.zTag); if (prize && prize.tag) t.push(prize.tag); return t; }
  function toZoko() {
    if (!C.zoko || design || !prize || !num) return;
    var done = st.zt || [], todo = zTags().filter(function (t) { return done.indexOf(norm(t)) < 0; });
    if (!todo.length) return;
    window.fetch(ZK_LIST + encodeURIComponent(C.shop || ''), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (list) {
        list = (Array.isArray(list) ? list : (list && list.data) || []).filter(function (c) { return c && c.id && c.active && c.shopify_active !== false; });
        var hits = 0;
        todo.forEach(function (tag) {
          var c = list.filter(function (x) { return norm(x.name) === norm(tag); })[0];
          if (!c) return;
          hits++;
          window.fetch(ZK_SUB + c.id + '/submission', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ whatsapp_number: '+' + C.cc + num, metadata: { mobile: /Mobi|Android/i.test(navigator.userAgent), timestamp: Date.now(), source: 'breakfree-scratch-card', prize: prize.tag || prize.id } }) })
            .then(function (r) { if (r.ok) { st.zt = (st.zt || []).concat(norm(tag)); save(); } }, function () {});
        });
        if (!hits) bridge();
      }, bridge);
  }
  /* no named campaigns in Zoko yet: send the number through the Zoko pop-up on the page, like before */
  function bridge() {
    if (st.z) return;
    var tries = 0;
    (function look() {
      var box = document.querySelector('.zoko_popup_campaign');
      var input = box && box.querySelector('input[type="tel"]');
      var btn = box && box.querySelector('button');
      if (!input || !btn) { if (++tries < 40) setTimeout(look, 500); return; }
      try {
        var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
        setter.call(input, String(C.cc) + num);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        setTimeout(function () { btn.click(); st.z = 1; save(); }, 250);
      } catch (err) { console.warn('[bf-welcome] could not send the number to Zoko', err); }
    })();
  }
  function track() {
    if (design || !prize || st.mt) return;
    var tag = prize.tag || prize.id;
    try { if (typeof window.fbq === 'function') { window.fbq('trackCustom', 'ScratchCard', { prize: tag, prize_name: cap(prize.core) }); st.mt = 1; save(); } } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bf_scratch_card', { prize: tag }); } catch (e) {}
  }

  /* ---------- scratch canvas ---------- */
  function initCanvas() {
    var c = ov.querySelector('.bfw-card canvas'); if (!c) return;
    var card = c.parentNode, w = card.clientWidth, h = card.clientHeight, dpr = Math.min(window.devicePixelRatio || 1, 2);
    c.width = w * dpr; c.height = h * dpr;
    var ctx = c.getContext('2d', { willReadFrequently: true }); ctx.scale(dpr, dpr);
    function paint() {
      if (c.getAttribute('data-touched')) return;
      ctx.globalCompositeOperation = 'source-over';
      var g = ctx.createLinearGradient(0, 0, w, h); g.addColorStop(0, '#E5465B'); g.addColorStop(.5, '#D7263D'); g.addColorStop(1, '#B81C31');
      ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(255,255,255,.09)';
      for (var y = -h; y < h * 2; y += 14) { ctx.save(); ctx.translate(0, y); ctx.rotate(-.35); ctx.fillRect(0, 0, w * 2, 5); ctx.restore(); }
      ctx.fillStyle = '#fff'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '400 ' + Math.round(h * .2) + 'px Anton, Impact, sans-serif'; ctx.fillText(T.scratch, w / 2, h / 2 - 8);
      ctx.font = '700 ' + Math.round(h * .068) + 'px Figtree, system-ui, sans-serif'; ctx.fillText(T.scratchSub, w / 2, h / 2 + h * .17);
    }
    paint();
    if (document.fonts && document.fonts.load) document.fonts.load('400 30px Anton').then(paint, function () {});
    function cleared() { var d = ctx.getImageData(0, 0, c.width, c.height).data, n = 0, t = 0; for (var i = 3; i < d.length; i += 96) { t++; if (d[i] === 0) n++; } return n / t; }
    function line(a, b) {
      ctx.globalCompositeOperation = 'destination-out'; ctx.lineWidth = 46; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.stroke();
      c.setAttribute('data-touched', '1');
    }
    SC = { w: w, h: h, line: line, cleared: cleared };
    var down = false, last = null, moves = 0;
    function pt(e) { var r = c.getBoundingClientRect(); return { x: (e.clientX - r.left) * (w / r.width), y: (e.clientY - r.top) * (h / r.height) }; }
    c.addEventListener('pointerdown', function (e) { if (step !== 'scratch') return; e.preventDefault(); down = true; SC.user = true; last = pt(e); try { c.setPointerCapture(e.pointerId); } catch (x) {} line(last, last); });
    c.addEventListener('pointermove', function (e) { if (!down || step !== 'scratch') return; var p = pt(e); line(last, p); last = p; if (++moves % 6 === 0 && cleared() > .5) finish(); });
    c.addEventListener('pointerup', function () { down = false; });
    c.addEventListener('pointercancel', function () { down = false; });
  }
  function finish(quiet) {
    if (step !== 'scratch') return;
    if (ov) {
      var c = ov.querySelector('.bfw-card canvas'), card = ov.querySelector('.bfw-card');
      if (c) { c.style.opacity = '0'; setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 460); }
      if (card) { card.classList.remove('live'); card.classList.add('done'); card.parentNode.classList.add('nohand'); }
      if (!quiet) { var b = ov.querySelector('.bfw-burst'); if (b) { b.classList.remove('go'); void b.offsetWidth; b.classList.add('go'); } }
    }
    clearTimeout(revealTimer); showReveal = false;
    step = 'won';
    startTimer();
    watch();
    if (isGift() && !st.ga) addGift();
    if (!quiet) render();
  }

  /* ---------- actions ---------- */
  function copyCode() {
    var code = prize.code;
    function fallback() { var t = document.createElement('textarea'); t.value = code; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0'; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(t); }
    try { var pr = navigator.clipboard && navigator.clipboard.writeText(code); if (pr && pr.then) pr.then(null, fallback); else fallback(); } catch (e) { fallback(); }
    copied = true; render();
  }
  function addGift(btn) {
    if (design || !GIFT) return;
    st.ga = 1; save();
    if (btn) btn.setAttribute('aria-busy', 'true');
    post('cart/add.js', { items: [{ id: GIFT.vid, quantity: 1, properties: { _bf_welcome: '1' } }] })
      .then(getCart).then(sync)
      .then(function () { render(); }, function (err) {
        if (btn) btn.removeAttribute('aria-busy');
        console.warn('[bf-welcome] could not add the free product', err);
      });
  }

  /* ---------- free product in the cart ---------- */
  function getCart() { return window.fetch(R + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function sameCode(a, b) { return String(a).toUpperCase() === String(b).toUpperCase(); }
  var addTries = 0, attrTried = false;
  function sync(cart) {
    if (!prize || !st.w || !cart || !cart.items || design) return cart;
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; }), job = null;
    if (prize.tag && !attrTried && (cart.attributes || {})['Welcome tag'] !== prize.tag) { attrTried = true; job = { attributes: attrsFor() }; }
    if (st.x) {
      if (giftKey) { giftKey = null; note(); }
    } else if (!isGift()) {
      if (!codes.some(function (c) { return sameCode(c, prize.code); }) && addTries < 8) { addTries++; job = job || {}; job.discount = codes.concat(prize.code).join(','); }
    } else if (GIFT) {
      var gl = null, others = 0;
      cart.items.forEach(function (i) { if (i.properties && i.properties._bf_welcome) { if (!gl) gl = i; } else others += i.original_line_price; });
      inCart = !!gl; giftKey = gl ? gl.key : null; giftOk = others > 0 && others >= MIN;
      var has = codes.some(function (c) { return sameCode(c, GIFT.code); }), want = inCart && giftOk;
      note();
      if (isOpen && step === 'won') render(); else if (pillEl) { hidePill(); showPill(); }
      if (want !== has && (!want || addTries < 8)) {
        if (want) addTries++;
        var list = codes.filter(function (c) { return !sameCode(c, GIFT.code); });
        if (want) list.push(GIFT.code);
        job = job || {}; job.discount = list.join(',');
      }
      if (gl && gl.quantity > 1) { job = job || {}; job.updates = {}; job.updates[gl.key] = 1; }
    }
    if (!job || syncing) return cart;
    syncing = true;
    return post('cart/update.js', job).then(function (c) { syncing = false; kRefresh(); return c; }, function () { syncing = false; return cart; });
  }
  function note() {
    [].forEach.call(document.querySelectorAll('.bfw-cnote'), function (n) { n.parentNode.removeChild(n); });
    if (!giftKey) return;
    var key = window.CSS && CSS.escape ? CSS.escape(giftKey) : giftKey;
    var lines = document.querySelectorAll('.bfk-ln[data-key="' + key + '"], [data-cart-item-key="' + key + '"]');
    [].forEach.call(lines, function (line) {
      var box = line.classList.contains('bfk-ln') && line.children[1] ? line.children[1] : line;
      var p = document.createElement('p');
      p.className = 'bfw-cnote' + (giftOk ? ' ok' : '');
      p.textContent = giftOk ? T.giftOk : T.giftNote;
      box.appendChild(p);
    });
  }
  var watching = false, watchT = null;
  function watch() {
    if (watching) return; watching = true;
    if (window.bfCart) { document.addEventListener('bf-cart:updated', function (e) { if (e.detail && e.detail.cart) sync(e.detail.cart); }); return; }
    var orig = window.fetch, re = /\/cart\/(add|change|update|clear)(\.js)?/;
    window.fetch = function (u) {
      var p = orig.apply(this, arguments);
      try { if (re.test(String(u && u.url || u))) p.then(function (r) { if (r && r.ok) { clearTimeout(watchT); watchT = setTimeout(function () { getCart().then(sync); }, 200); } }, function () {}); } catch (e) {}
      return p;
    };
  }

  function openCart() {
    if (window.bfCart && bfCart.refresh) { bfCart.refresh().then(function () { bfCart.open(); }); return; }
    var k = window.kachingCartApi;
    if (k && k.openCart) { try { if (k.refreshCart) k.refreshCart(); k.openCart(); return; } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
    setTimeout(function () { if (!document.documentElement.classList.contains('bfk-lock')) location.href = R + 'cart'; }, 600);
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-bfw]') : null; if (!t) return;
    var a = t.getAttribute('data-bfw');
    if (a === 'close') close();
    else if (a === 'next') { setStep('number'); var i = ov && ov.querySelector('.bfw-field input'); if (i) { try { i.focus({ preventScroll: true }); } catch (x) { i.focus(); } } }
    else if (a === 'copy') copyCode();
    else if (a === 'reveal') finish();
    else if (a === 'add') addGift(t);
    else if (a === 'cart') { close(); openCart(); }
    else if (a === 'reopen') open();
    else if (a === 'pilloff') { try { sessionStorage.setItem('bfw-pill-off', '1'); } catch (x) {} hidePill(); }
  });
  root.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'bfw-phone') { var f = e.target.form; f.querySelector('.bfw-field').classList.remove('err'); f.querySelector('.bfw-err').textContent = ''; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  /* ---------- when to show ---------- */
  var timer = null;
  function onScroll() { var d = document.documentElement, max = d.scrollHeight - window.innerHeight; if (max > 200 && window.scrollY / max >= .5) open(); }
  function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) open(); }
  function arm() {
    if (armed) return; armed = true;
    timer = setTimeout(open, Math.max(0, C.delay || 0) * 1000);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (C.exit && window.matchMedia && matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onLeave);
  }
  function disarm() {
    clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onLeave);
  }

  if (design) {
    if (C.editor) setTimeout(open, 600);
    document.addEventListener('shopify:section:select', function (e) { if (e.target && /bf-welcome/.test(e.target.id || '')) { step = 'intro'; prize = null; if (!isOpen) open(); } });
  } else if (step === 'won') {
    var fresh = Date.now() - (st.t || 0) < 30 * DAY;
    if (MINS && !st.e && !st.x && !st.c) { st.e = Date.now() + SPAN; save(); }
    if (st.x || !fresh) { /* expired or old: nothing to show */ }
    else if (timerOn() && left() <= 0) expire();
    else { watch(); getCart().then(sync); if (C.popup !== false) showPill(); startTick(); }
    if (st.n && prize) { num = st.n; toZoko(); track(); }
  } else if (C.popup !== false) {
    if (st.until && Date.now() < st.until) showPill(); else arm();
  }

  window.bfWelcome = { open: open, close: close, left: function () { return timerOn() ? left() : 0; }, reset: function () { try { localStorage.removeItem(KEY); sessionStorage.removeItem('bfw-pill-off'); } catch (e) {} } };
})();
